import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Grid,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import BlockDialogUI from "./BlockDialogUI";
import { Button } from "react-bootstrap";
import { throttle } from "../Utils/utils";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const CommonDialog = ({
  open,
  onClose,
  title,
  handleSubmit,
  action = true,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      scroll="body"
      aria-labelledby="draggable-dialog-title"
      fullWidth
      maxWidth="md"
    >
      <BlockDialogUI>
        <DialogTitle
          dividers
          style={{ backgroundColor: "#f2674a", color: "white" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
            <IconButton aria-label="close" onClick={onClose} size="small">
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#2c2c2c" }}>
          <Grid container sx={{ marginLeft:"8px" }} >
            {children}
          </Grid>
        </DialogContent>
        {action && (
          <DialogActions dividers sx={{ backgroundColor: "#2c2c2c" }}>
            <Box>
              <Button onClick={onClose} variant="gray" type="button">
                Cancel
              </Button>
            </Box>
            <Box>
              <Button
                variant="primary"
                type="button"
                className="btn btn-primary btn-icon-text"
                onClick={throttle(handleSubmit)}
              >
                Submit
              </Button>
            </Box>
          </DialogActions>
        )}
      </BlockDialogUI>
    </Dialog>
  );
};

export default CommonDialog;
